import store from '@/store'

export default () => {
    return {
        headers: {
            Authorization: `Bearer ${store.getters['user/Token']}`,
        }
    };
};